module.exports = {"530402001":"玉兴路街道","530402002":"凤凰路街道","530402003":"玉带路街道","530402004":"北城街道","530402005":"春和街道","530402006":"李棋街道","530402007":"大营街街道","530402008":"研和街道","530402009":"高仓街道","530402201":"小石桥乡","530402202":"洛河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530402.json
// module id = 2374
// module chunks = 0